import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";

export const defaultChoices = (check) => Object.fromEntries((check?.unmatched || []).map((u) => [u.name, u.suggestions[0]?.score >= 80 ? u.suggestions[0].id : u.storage_clash ? "none" : "new"]));

function LinkRow({ u, rows, labs, value, onChange }) {
  const suggested = new Set(u.suggestions.map((s) => s.id));
  return (
    <div className="flex flex-wrap items-center gap-2 py-2 border-t first:border-t-0" data-testid={`lab-link-row-${u.name}`}>
      <div className="min-w-[140px] flex-1">
        <div className="font-medium text-sm">“{u.name}”</div>
        <div className="text-[11px] text-muted-foreground">{rows} lesson{rows === 1 ? "" : "s"}{u.storage_clash && ` · matches storage area ${u.storage_clash}`}{u.suggestions[0] && ` · closest: ${u.suggestions[0].name}`}</div>
      </div>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-64 max-w-full h-9" data-testid={`lab-link-select-${u.name}`}><SelectValue /></SelectTrigger>
        <SelectContent>
          {!u.storage_clash && <SelectItem value="new">Add as a new lab</SelectItem>}
          <SelectItem value="none">Save lessons without a lab</SelectItem>
          {u.suggestions.length > 0 && <SelectGroup><SelectLabel>Suggested</SelectLabel>{u.suggestions.map((s) => <SelectItem key={s.id} value={s.id}>Same as {s.name}</SelectItem>)}</SelectGroup>}
          <SelectGroup><SelectLabel>All labs</SelectLabel>{labs.filter((l) => !suggested.has(l.id)).map((l) => <SelectItem key={l.id} value={l.id}>Same as {l.name}</SelectItem>)}</SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
}

export function LabLinker({ check, records, choices, setChoices }) {
  if (!check) return <p className="text-xs text-muted-foreground" data-testid="lab-check-loading">Checking lab names…</p>;
  const count = (n) => records.filter((r) => String(r.lab || "").trim() === n).length;
  const live = check.unmatched.filter((u) => count(u.name) > 0);
  if (!live.length) {
    return <p className="text-xs flex items-center gap-1.5 text-emerald-700 dark:text-emerald-400" data-testid="lab-check-ok"><CheckCircle2 className="h-3.5 w-3.5" />All lab names match labs you already have.</p>;
  }
  return (
    <div className="rounded-lg border border-amber-500/40 bg-amber-500/5 p-3" data-testid="lab-check-panel">
      <div className="flex items-center gap-2 text-sm font-semibold"><AlertTriangle className="h-4 w-4 text-amber-600" />{live.length} lab name{live.length === 1 ? "" : "s"} not recognised</div>
      <p className="text-xs text-muted-foreground mt-0.5 mb-1">Do any of these correspond to a lab you already have? Linking one remembers the name, so future uploads match automatically.</p>
      {live.map((u) => <LinkRow key={u.name} u={u} rows={count(u.name)} labs={check.labs} value={choices[u.name] || (u.storage_clash ? "none" : "new")} onChange={(v) => setChoices({ ...choices, [u.name]: v })} />)}
    </div>
  );
}
